"use client";

import { useStorage } from "../../useStorage";
import { Sheet, SheetContent } from "@/components/ui/sheet";
import { useGetLomda } from "./hooks/useGetLomda";
import { LoaderCircle } from "lucide-react";
import LomdaSheetMain from "./components/main";
import LomdaSheetHeader from "./components/header/header";
import LomdaSheetAside from "./components/aside";
import { t } from "@/lib/localization";

export default function LomdaSheet() {
    const [open, setOpen, options] = useStorage((state) => [
        state.lomdaSheetOpen,
        state.setLomdaSheetOpen,
        state.lomdaOptions,
    ]);

    const { isPending, data } = useGetLomda(
        open && !!options.lomdaId && !!options.libraryId,
        options.lomdaId
    );
    const lomda = data?.data;

    return (
        <Sheet open={open} onOpenChange={(open) => setOpen(open)}>
            <SheetContent
                className="bg-muted !p-0 w-full sm:w-[80vw] sm:max-w-[1200px]"
                xClassName="sm:top-4 sm:-left-10 sm:flex sm:justify-center sm:items-center sm:rounded-full sm:bg-white sm:size-6"
            >
                {isPending || !lomda ? (
                    <div className="flex w-full h-full justify-center items-center">
                        <LoaderCircle className="size-6 animate-spin" />
                    </div>
                ) : (
                    <>
                        <LomdaSheetHeader lomda={lomda} />

                        <div className="flex overflow-y-auto h-[calc(100%-64px)] flex-col lg:flex-row">
                            <LomdaSheetAside lomda={lomda} />
                            <LomdaSheetMain lomda={lomda} />
                        </div>
                    </>
                )}
            </SheetContent>
        </Sheet>
    );
}
